import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { parseAmazonPage } from './parser'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function getAmazonButtonHost (): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>('#bylineInfo') ||
    document.querySelector<HTMLElement>('#title') ||
    document.querySelector<HTMLElement>('#centerCol')
  )
}

function isAmazonBookPage (): boolean {
  return /\/dp\//.test(window.location.pathname) || /\/gp\/product\//.test(window.location.pathname)
}

export function injectAmazonPortButton (): void {
  if (!isAmazonBookPage()) return

  const host = getAmazonButtonHost()
  if (!host) return

  const existing = document.getElementById('amazon-port-to-sg-btn') as HTMLAnchorElement | null
  if (existing) {
    if (existing.parentElement !== host) host.appendChild(existing)
    return
  }

  const btn = document.createElement('a')
  btn.id = 'amazon-port-to-sg-btn'
  btn.href = '#'
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = STORYGRAPH_PILL_STYLE
  host.appendChild(btn)

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseAmazonPage()
    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
